import { Routes } from 'constants/routeConstants';

export const SEGMENT_SKIP_TRACK_ROUTES = [
  Routes.AUTH_MFA_INPUT,
  Routes.AUTH_FORCE_PASSWORD_CHANGE,
  Routes.AUTH_EMAIL_VERIFICATION,
  Routes.AUTH_MFA_REQUIRED,
  Routes.AUTH_MFA_SETUP,
  Routes.AUTH_PHONE_VERIFICATION,
];
